import { useTranslation } from "react-i18next"
import { ExternalUserProps } from "./types"
import { useStyles } from "./styles"
import { Box, Tooltip, Typography } from "@mui/material"
import { memo } from "react"
import { MultiEmailInput } from "../multiEmailInput"
import { PageOptionGroup } from "../../../../utils/enums/page"


const ExternalUserComponent = ({ emails, setEmails, errors, setErrors, mode }: ExternalUserProps) => {

    const { t } = useTranslation()
    const styles = useStyles()



    return (
        <Box sx={styles.container}>
            <Typography fontWeight={'bold'}>{t('userGroup.titles.externalUser')}</Typography>
            {mode == PageOptionGroup.DETAIL ?
                <Box sx={styles.emails}>
                    {emails.map(email => (
                        <Tooltip title={email}>
                            <Typography sx={styles.email}>{email}</Typography>
                        </Tooltip>
                    ))}
                </Box>
                :
                <>
                    <Typography variant="subtitle_grey">{t('userGroup.text.whenEnteringMoreThanOneEmailAddressSeparatedComma')}</Typography>
                    <MultiEmailInput
                        value={emails.join(", ")}
                        onChange={(list) => setEmails(list)}
                        errors={errors}
                        setErrors={setErrors}
                    /></>
            }
        </Box>
    )
}

export const ExternalUser = memo(ExternalUserComponent)